import React from 'react'

const HeaderContactItem = ({ icon, content, link }) => {

  return (
    <div className="header-contact-item">
      <div className="header-contact-item-icon">
        { link === undefined ? (
          <img src={icon} alt="" />
        ) : (
          <a href={ link } target="new">
            <img src={icon} alt="" />
          </a>
        ) }
      </div>
      <div className="header-contact-item-line"></div>
      <div className="header-contact-item-content">
        { link === undefined ? (
          content
        ) : (
          <a href={ link } target="new">
            { content }
          </a>
        ) }
      </div>
      
    </div>
  )
}

export default HeaderContactItem